import React, { Component } from 'react';
import {Col, Image, Row, Typography} from "antd";
import Texts from "../../../utils/Text";
import './product.css';
import software from "../Products/images/software.png";
import servers from "../Products/images/servers.png";
import dbsystem from "../Products/images/dbsystem.png";
import charge from "../Products/images/charge.png";
import ozu from "../Products/images/ozu.png";
import sib from "../Products/images/sib.png";
import videocard from "../Products/images/videocard.png";
import izmeritel from "../Products/images/izmeritel.png";
import cpu from "../Products/images/cpu.png";
import telephone from "../Products/images/telephone.png";
import commutator from "../Products/images/commutator.png";
import pc from "../Products/images/pc.png";


const { Text } = Typography;

export default class Products extends Component {
    state = {
        isMobile: window.screen.width < 769,
        products: [
            [software, servers, dbsystem, pc],
            [ozu, cpu, sib, telephone],
            [izmeritel, charge, videocard, commutator]
        ]
    }
    render() {
        const { products, isMobile } = this.state;
        return (
            <div className="main-content" >
                <div className="montserrat" style={{width: '100%'}}>
                    <Row justify="center" style={{ fontSize: "36px", paddingTop: '100px', marginBottom: '130px'}}>
                        <Text style={{textAlign: 'center'}}>{Texts('products', 'title')}</Text>
                    </Row>
                    {isMobile ?
                        products.map((product, index) => (
                            <Row justify="center" style={{ maxWidth: '499px', fontSize: "16px", marginLeft: 'auto', marginRight: 'auto'}}>
                                {product.map((item, index2) => (
                                    <Row justify="center">
                                        <div className="card">
                                            <div className="img">
                                                <Image style={{borderRadius: '65px'}} preview={false} src={item} width={127} height={127}/>
                                            </div>
                                            <div style={{paddingTop: "70px", textAlign: 'center'}}>
                                                <Text>{Texts('products', `h${index + 1}${index2 + 1}`)}</Text>
                                            </div>
                                        </div>
                                    </Row>
                                ))}
                            </Row>
                        ))
                        :
                        products.map((product, index) => (
                            <Row justify="center" style={{ fontSize: "16px", marginLeft: 'auto', marginRight: 'auto', marginBottom: '100px'}}>
                                {product.map((item, index2) => (
                                    <Col span={6} className="colon" style={{textAlign: 'center'}}>
                                        <Row justify="center">
                                            <div className="card">
                                                <div className="img">
                                                    <Image style={{borderRadius: '65px'}} preview={false} src={item} width={127} height={127}/>
                                                </div>
                                                <div style={{paddingTop: "70px"}}>
                                                    <Text>{Texts('products', `h${index + 1}${index2 + 1}`)}</Text>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                ))}
                            </Row>
                        ))
                    }
                </div>
            </div>
        );
    }
}

